import { unzipSync } from 'fflate';

/** A zip holding `canvas.fig` is a FigJam `.jam` (docs/spikes/P11c-jam-format.md). Reads the file list only, inflates nothing. */
export function isJam(bytes: Uint8Array): boolean {
  if (!(bytes[0] === 0x50 && bytes[1] === 0x4b && bytes[2] === 0x03 && bytes[3] === 0x04)) return false;
  let found = false;
  try {
    unzipSync(bytes, {
      filter: (f) => {
        if (f.name === 'canvas.fig') found = true;
        return false;
      },
    });
  } catch {
    return false;
  }
  return found;
}
